import {createSlice} from '@reduxjs/toolkit'

const walletConfig = createSlice({
  name: 'walletConfig',
  initialState: {
    hideSmallBalances: false,
  },
  reducers: {
    toggleShowBalances(state, {payload}) {
      if (payload == null) state.hideSmallBalances = !state.hideSmallBalances
      else state.hideSmallBalances = payload
    },
  },
})

export const {toggleShowBalances} = walletConfig.actions
export default walletConfig
